import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initErrorReporting } from './lib/errorReporting';

// Before render, so a crash during the first paint is still captured.
// No-op unless REACT_APP_SENTRY_DSN is set.
initErrorReporting();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
